export default __webpack_public_path__ + "static/media/cross-icon.4fce88ab.svg";